import {defineStore} from 'pinia';
import {ModuleBudgetDistribution} from '../moduleConst';
import BudgetDistributionAPI from '@/apis/di/budgetDistributionAPI.js';
import {BaseDictionaryStore} from '@/stores/baseDictionaryStore';
const budgetDistributionStore = new BaseDictionaryStore(BudgetDistributionAPI);
export const useBudgetDistributionStore = defineStore(ModuleBudgetDistribution, {
  state: () => ({
    ...budgetDistributionStore.state,
    _config: {
      key: 'budget_distribution_id',
      code: 'budget_distribution_code',
      name: 'budget_distribution_name',
      table: 'di_budget_distribution',
      moduleName: 'Cấp ngân sách',
      defaultSort: 'budget_distribution_code',
    },
    moduleName: 'diBudgetDistribution',
  }),
  actions: {...budgetDistributionStore.action},
  getters: {
    ...budgetDistributionStore.getters,
  },
});
